<div
  class="checkbox-group"
  *ngFor="let checkbox of statusData"
>
  <mat-checkbox
    #checkbox_status
    (change)="setValueFormArray($event, checkbox.status)"
    [name]="checkbox.status"
  ></mat-checkbox>
  <span
    style="cursor: pointer"
    (click)="getCheckboxStatusFormArray(checkbox_status, checkbox.status)"
    >{{ checkbox.status }}</span
  >
</div>
